import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Switch,
} from '@chakra-ui/react';

import { ContractFormFields } from 'page/CustomerPage/types/contractFormField';

type Props = {
  register: UseFormRegister<ContractFormFields>;
  error: FieldError | undefined;
};

/**
 * 有効/無効のフォームです。
 */
export const ValidForm: FC<Props> = ({ register, error }: Props) => (
  <FormControl
    isRequired
    isInvalid={Boolean(error)}
    display="flex"
    alignItems="center"
  >
    <FormLabel>有効</FormLabel>
    <Switch id="valid" size="md" {...register('valid')} />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
